(() => {

const MAX = 2;

function init(root){

const trigger = root.querySelector(".fp-trigger");
const modal = root.querySelector(".fp-modal");
const grid = root.querySelector(".fp-grid");
const confirmBtn = root.querySelector(".fp-confirm");
const errorBox = root.querySelector(".fp-error");
const summaryText = root.querySelector(".fp-summary-text");

const prop1 = root.querySelector(".fp-prop-1");
const prop2 = root.querySelector(".fp-prop-2");
const propAll = root.querySelector(".fp-prop-all");

const dataEl = root.querySelector(".fp-data");
const form = root.closest("form");
const atcBtn = form ? form.querySelector(".fp-atc-btn") : null;

if(!dataEl || !form) return;

let data = JSON.parse(dataEl.textContent.trim());

/* no default selection */
let counts = {};
data.forEach(item => counts[item.id] = 0);

let confirmed = false;

function totalSelected(){
return Object.values(counts).reduce((a,b)=>a+b,0);
}

function syncProperties(){

let selected = [];

data.forEach(item=>{
for(let i=0;i<counts[item.id];i++){
selected.push(item);
}
});

const f1 = selected[0]?.title || "";
const f2 = selected[1]?.title || "";
const combined = selected.map(x=>x.title).join(", ");

prop1.value = f1;
prop2.value = f2;
propAll.value = combined;

summaryText.textContent = combined || "No fragrances selected";

}

function render(){

grid.innerHTML = data.map(item=>{

const count = counts[item.id];
const active = count > 0;

return `
<div class="fp-card ${active?"fp-selected":""}">

<div class="fp-thumb">
<img src="${item.image}" alt="${item.title}">
</div>

<div class="fp-name">${item.title}</div>

<div class="fp-card-actions">

<button
type="button"
class="fp-btn view-btn"
data-view="${item.image}">
View
</button>

${
count===0
? `
<button
type="button"
class="fp-btn select"
data-select="${item.id}">
Select
</button>
`
:`
<div class="fp-counter">

<button
type="button"
class="fp-minus"
data-minus="${item.id}">
-
</button>

<span class="fp-count">${count}</span>

<button
type="button"
class="fp-plus"
data-plus="${item.id}"
${totalSelected()>=MAX?'disabled':''}>
+
</button>

</div>
`
}

</div>

</div>
`;

}).join("");

}

function openModal(){

modal.hidden=false;
document.body.classList.add("fp-scroll-lock");
render();

}

function closeModal(){

modal.hidden=true;
document.body.classList.remove("fp-scroll-lock");

}

function refresh(){

syncProperties();
render();

}

/* popup clicks */

modal.addEventListener("click",(e)=>{

if(e.target.closest("[data-fp-close]")){
closeModal();
return;
}

/* select */

const select = e.target.closest("[data-select]");
if(select){

const id = select.dataset.select;

if(totalSelected()<MAX){

counts[id] = 1;
confirmed=false;
refresh();

}

}

/* plus */

const plus = e.target.closest("[data-plus]");
if(plus){

const id = plus.dataset.plus;

if(totalSelected()<MAX){

counts[id]++;
confirmed=false;
refresh();

}

}

/* minus */

const minus = e.target.closest("[data-minus]");
if(minus){

const id = minus.dataset.minus;

if(counts[id]>0){

counts[id]--;
confirmed=false;
refresh();

}

}

});

/* confirm */

confirmBtn.addEventListener("click",(e)=>{

e.preventDefault();

if(totalSelected()!==MAX){

errorBox.textContent="Please select 2 fragrances";
return;

}

confirmed=true;

syncProperties();

closeModal();

if(form.dataset.fpPendingSubmit==="true"){

form.dataset.fpPendingSubmit="false";

HTMLFormElement.prototype.submit.call(form);

}

});

/* add to cart */

const requireConfirm=(e)=>{

syncProperties();

if(totalSelected()===MAX && confirmed){
return;
}

e.preventDefault();
e.stopImmediatePropagation();

form.dataset.fpPendingSubmit="true";

openModal();

errorBox.textContent="Please select 2 fragrances";

};

form.addEventListener("submit",requireConfirm,true);

if(atcBtn){
atcBtn.addEventListener("click",requireConfirm,true);
}

/* trigger */

trigger.addEventListener("click",openModal);

/* init */

syncProperties();
render();

}

document.addEventListener("DOMContentLoaded",()=>{

document.querySelectorAll("[data-fp-root]").forEach(init);

});

})();